import React from 'react';
import DOMPurify from 'dompurify';
import Remarkable from 'remarkable';

const md = new Remarkable({
    html: true,
    breaks: true,
    linkify: true,
});

const Markdown = ({ content, ...props }) => {
    if (content) {
        return (<div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(md.render(content)) }}
            {...props}
        />);
    }
    return null;
};

Markdown.propTypes = {
    content: React.PropTypes.string,
};

export default Markdown;



/** WEBPACK FOOTER **
 ** ./src/Components/Markdown.js
 **/